import { FormattedMessage } from "react-intl";
import Icon from "../../foundations/Icons/Icon";
import FileTrigger from "../FileTrigger/FileTrigger";
import IconButton from "../IconButton/IconButton";
import Link from "../Link/Link";
import ProfileImage from "../ProfileImage/ProfileImage";

interface Props {
  src?: string;
  isTeam?: boolean;
  isDisabled?: boolean;
  onChange: (file: FileList | null) => void;
  onDelete: () => void;
}

export default function ImagePicker({
  src,
  isTeam = false,
  isDisabled = false,
  onChange,
  onDelete,
}: Props) {
  return (
    <div className="relative size-34 mb-4 group" aria-label="Image picker">
      {!isDisabled && (
        <div className="absolute w-full h-full rounded-full bg-black/50 opacity-0 group-hover:opacity-100 z-10 transition-all duration-200 flex flex-col justify-center items-center gap-3">
          {src ? (
            <>
              <FileTrigger
                label="replace picture"
                onSelect={onChange}
                acceptedFileTypes={["image/*"]}
              >
                <Link variant="link-4" className="text-white">
                  <FormattedMessage id="image_picker_replace" />
                </Link>
              </FileTrigger>
              <Icon icon="photo" size="sm" className="bg-white" />
              <Link onPress={onDelete} variant="link-4" className="text-white">
                <FormattedMessage id="image_picker_remove" />
              </Link>
            </>
          ) : (
            <FileTrigger
              label="add picture"
              acceptedFileTypes={["image/*"]}
              onSelect={onChange}
            >
              <IconButton
                color="transparent"
                iconClassName="bg-white"
                icon="plus"
              />
            </FileTrigger>
          )}
        </div>
      )}
      <ProfileImage
        className="w-full h-full absolute"
        src={src}
        alt="profile picture"
        isTeam={isTeam}
      />
    </div>
  );
}
